import InstallerSimulator from './InstallerSimulator.jsx';

/** Adapts the checkbox_sim question payload to the reusable <InstallerSimulator>. */
export default function CheckboxSimQuestion({ question, answered, onSubmit }) {
  const { payload, revealed } = question;
  const isLocked = answered || Boolean(revealed);

  return (
    <div className="card stack">
      <div className="row-between">
        <span className="q-kicker">ลองใช้งานจริง</span>
      </div>

      <InstallerSimulator
        windowTitle={payload.windowTitle}
        heading={payload.heading}
        checkboxes={payload.checkboxes}
        submitLabel={payload.submitLabel}
        disabled={isLocked}
        onSubmit={(checkedIndices) => !isLocked && onSubmit({ checked: checkedIndices })}
      />

      {isLocked && (
        <p className="text-dim text-center">
          {answered ? 'ส่งคำตอบแล้ว รอครูเฉลย...' : 'เฉลยคำตอบแล้ว — ปิดรับคำตอบข้อนี้'}
        </p>
      )}
    </div>
  );
}
